module.exports = __webpack_public_path__ + "static/media/nothingfound.3fc906a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nothingfound.png
// module id = 120
// module chunks = 0